import {
  Component,
  Input,
  ChangeDetectionStrategy
} from '@angular/core';

import {
  ListViewChecklistItemModel
} from './state/items/item.model';


export class SkyListViewChecklistItemComponent {
  
  public item: ListViewChecklistItemModel;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-list-view-checklist-item',
  template: `<div class="sky-list-view-checklist-item">
  <ng-content></ng-content>
</div>
`,
  styles: [`.sky-list-view-checklist-item {
  display: block;
  width: 100%;
  cursor: pointer;
}

.sky-list-view-checklist-item:last-child {
  border-bottom-width: 0;
}

.sky-list-view-checklist-item /deep/ sky-checkbox {
  display: block;
  position: relative;
  width: 100%;
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px dotted #cdcfd2;
}

.sky-list-view-checklist-item /deep/ sky-checkbox-label {
  flex: 1;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  padding-left: 10px;
}

.sky-list-view-checklist-item /deep/ sky-checkbox-label div {
  overflow: hidden;
  text-overflow: ellipsis;
}

.sky-list-view-checklist-item /deep/ .sky-list-view-checklist-single-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px dotted #cdcfd2;
  display: block;
  text-align: left;
  margin-bottom: 0;
  padding: 10px;
  width: 100%;
  cursor: pointer;
}

.sky-list-view-checklist-item /deep/ .sky-list-view-checklist-single-button.sky-list-view-checklist-row-selected {
  background-color: #f1eef6;
}
`],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'item': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
